import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';

export class ServiceUtilities {
    constructor() { }

    public getStandardHeaderOptions(): RequestOptions {
        let headers = new Headers({
            'Content': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Accept': 'q=0.8;application/json;q=0.9',
            'Pragma': 'no-cache',
            'Cache-Control': 'no-cache',
            'Authorization': 'bearer ' + this.getTokenFromCookie()
        });

        let options = new RequestOptions({ headers: headers });
        return options;
    }

    public handleError(error: Response | any) {
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return Observable.throw(errMsg);
    }

    public getBaseURLFromCookie(): string {
        let name = 'baseURL';
        let baseURL = ''
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) { baseURL= match[1].toString(); }

        return baseURL;
    }

    public getTokenFromCookie(): string {
        let name = 'Bearer';
        let tokenData = ''
        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) { tokenData = match[1].toString(); }

        return tokenData;
    }

    public getEnvironmentFromCookie(): string {
        let name = 'isProd';
        let environment = '';

        let match = document.cookie.match(new RegExp(name + '=([^;]+)'));
        if (match) { environment = match[1].toString(); }

        return environment;
    }

    public getBearerTokenForHeader(): string {
        return ('bearer ' + this.getTokenFromCookie());
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/services/service-utilities.ts